import request from '@/utils/request'

export const ranksGet = (options = {}) => request({
    url: '/quiz_apis/ranks',
    method: 'get',
    ...options
})

export const myRankGet = (options = {}) => request({
    url: '/quiz_apis/my/rank',
    method: 'get',
    ...options
})
